import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IntSelectModel } from "services/api/cplapi/CPLAPI";
import { IFundSchedulesService } from "services/FundSchedulesService";
import { RootState } from "setup";
import { container } from "setup/dependency/inversify.config";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

const initialState = {
  FundScheduleChargeTypeSelectModels: new Array<IntSelectModel>(),
  Loading: false,
  LastUpdateTime: new Date(),
};

export const fundScheduleChargeTypeSelectSlice = createSlice({
  name: "fundScheduleChargeTypeSelect",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFundScheduleChargeTypeSelectModels.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getFundScheduleChargeTypeSelectModels.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(getFundScheduleChargeTypeSelectModels.fulfilled, (state, action) => {
        state.FundScheduleChargeTypeSelectModels = action.payload;
        state.Loading = false;
        state.LastUpdateTime = new Date();
      });
  },
});

export const getFundScheduleChargeTypeSelectModels = createAsyncThunk(
  "FundSchedule/GetFundScheduleChargeTypesSelectModels",
  async () => {
    const fundSchedulesService = container.get<IFundSchedulesService>(SERVICE_TYPES.FundSchedulesService);
    return await fundSchedulesService.getFundScheduleChargeTypeSelectModels();
  }
);

export const selectFundScheduleChargeTypeSelectModels = (state: RootState) => {
  return state.fundScheduleChargeTypeSelect.FundScheduleChargeTypeSelectModels;
};

export const selectLoading = (state: RootState) => {
  return state.fundScheduleChargeTypeSelect.Loading;
};

export const selectLastUpdateTime = (state: RootState) => {
  return state.fundScheduleChargeTypeSelect.LastUpdateTime;
};

export default fundScheduleChargeTypeSelectSlice.reducer;
